export const generalConfig = {
  SUPER_ADMIN_CLIENT_ID: "100000"
}